import { render } from "./ElectronicFinancePage.vue?vue&type=template&id=0676c71d"
import script from "./ElectronicFinancePage.vue?vue&type=script&lang=js"
export * from "./ElectronicFinancePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__